import axios from 'axios'
import { API_ENDPOINT } from '../../../../config'
import store from '../../../../redux/stores/store'
import Validation from '../../../../data/validation/validation'
import { StringValidationRule, PhoneValidationRule, EmailValidationRule } from '../../../../data/validation/rules'

const getDefaultState = () => {
    return {
        updating: false,
        loadingAuthor: true,
        title: "",
        firstname: "",
        lastname: "",
        phone: "",
        email: "",
        affiliations: "",
        errors: {},
        flag: {
            type: "",
            text: ""
        }
    }
}

const loadAuthor = instance => {
    axios({
        method: 'get',
        url: API_ENDPOINT + "/api/publisher/authors/" + instance.props.match.params.id,
        headers: {
            "Authorization": store.getState().auth.jwt
        }
    }).then(response => handleLoadAuthorResponse(instance, response))
        .catch(error => alert(error))
}

const handleLoadAuthorResponse = (instance, response) => {
    if (response.status !== 200) {
        return
    }
    switch (response.data.status) {
        case 200:
            instance.setState({
                ...instance.state,
                loadingAuthor: false,
                title: response.data.data.author.title,
                firstname: response.data.data.author.firstname,
                lastname: response.data.data.author.lastname,
                phone: response.data.data.author.phone,
                email: response.data.data.author.email,
                affiliations: response.data.data.author.affiliations,
                flag: {
                    type: "",
                    text: ""
                }
            })
            break
        default:
            instance.setState({
                ...instance.state,
                updating: false,
                flag: {
                    type: "error",
                    text: response.data.message
                }
            })
    }
}

const isValid = instance => {
    let validation = new Validation()
    let errors = instance.state.errors
    validation.addValidationRule(StringValidationRule, instance.state.title, (error) => errors.firstname = error, { min: { value: 2, error: "Too short" }, max: { value: 15, error: "Too long" } })
    validation.addValidationRule(StringValidationRule, instance.state.firstname, (error) => errors.firstname = error, { min: { value: 2, error: "Too short" }, max: { value: 25, error: "Too long" } })
    validation.addValidationRule(StringValidationRule, instance.state.lastname, (error) => errors.lastname = error, { min: { value: 2, error: "Too short" }, max: { value: 25, error: "Too long" } })
    validation.addValidationRule(PhoneValidationRule, instance.state.phone, (error) => errors.phone = error, { allowNull: true })
    validation.addValidationRule(EmailValidationRule, instance.state.email, (error) => errors.email = error, { allowNull: true })
    validation.addValidationRule(StringValidationRule, instance.state.affiliations, (error) => errors.affiliations = error, { min: { value: 0, error: "Too short" }, max: { value: 300, error: "Too long" } })
    let validate = validation.validate()
    let stateUpdate = {
        errors: errors,
        flag: {
            type: validate ? "" : "error",
            text: validate ? "" : "Validation Failure"
        }
    }
    instance.setState({
        ...instance.state,
        ...stateUpdate
    })
    return validate
}

const updateAuthor = (instance) => {
    instance.setState({
        ...instance.state,
        updating: true
    })
    axios({
        method: 'post',
        url: API_ENDPOINT + "/api/publisher/authors/update",
        headers: {
            "Authorization": store.getState().auth.jwt
        },
        data: {
            id: instance.props.match.params.id,
            title: instance.state.title,
            firstname: instance.state.firstname,
            lastname: instance.state.lastname,
            phone: instance.state.phone,
            email: instance.state.email,
            affiliations: instance.state.affiliations,
        }
    }).then(response => handleUpdateAuthorResponse(instance, response))
        .catch(error => alert(error))
}

const handleUpdateAuthorResponse = (instance, response) => {
    if (response.status !== 200) {
        return
    }
    switch (response.data.status) {
        case 200:
            instance.setState({
                ...instance.state,
                updating: false,
                flag: {
                    type: "success",
                    text: "Author Updated"
                }
            })
            break
        default:
            instance.setState({
                ...instance.state,
                updating: false,
                flag: {
                    type: "error",
                    text: response.data.message
                }
            })
    }
}

const EditAuthorWorker = instance => {
    return {
        getDefaultState: getDefaultState,
        loadAuthor: () => loadAuthor(instance),
        isValid: () => isValid(instance),
        updateAuthor: () => updateAuthor(instance)
    }
}

export default EditAuthorWorker